const GCS_DOWNLOAD_API_REGEX =
	/^https:\/\/storage\.googleapis\.com\/download\/storage\/v1\/b\/([^/]+)\/o\/([^?]+)/

export const CAMPAIGN_IMAGE_STORAGE_FOLDER = 'offers'
export const CAMPAIGN_IMAGE_ACCEPTED_EXTENSIONS = '.png,.jpeg,.jpg'
export const CAMPAIGN_IMAGE_ACCEPTED_MIME_TYPES = [
	'image/png',
	'image/jpeg',
	'image/jpg',
]
export const CAMPAIGN_IMAGE_MAX_BYTES = 500_000
export const CAMPAIGN_IMAGE_TOO_BIG_MSG =
	"L'image dépasse la taille maximale de 500 Ko."
export const CAMPAIGN_IMAGE_BAD_TYPE_MSG =
	"L'image doit être au format PNG, JPG ou JPEG."
export const CAMPAIGN_IMAGE_REQUIRED_MSG =
	'Image obligatoire : ajoutez un visuel (PNG ou JPG, 500 Ko max).'
export const CAMPAIGN_NAME_REQUIRED_MSG =
	'Titre obligatoire : donnez un nom à votre campagne.'

export interface NormalizeCampaignImageUrlResult {
	url: string | null
	error?: string
}

export function normalizeCampaignImageUrl(
	raw: unknown,
): NormalizeCampaignImageUrlResult {
	if (raw === null || raw === undefined) {
		return { url: null }
	}

	const trimmed = String(raw).trim()
	if (!trimmed) {
		return { url: null }
	}

	if (
		trimmed.startsWith('data:') ||
		trimmed.startsWith('blob:') ||
		trimmed.startsWith('file:')
	) {
		return { url: null, error: 'Invalid URL scheme' }
	}

	if (trimmed.startsWith('http://')) {
		return { url: null, error: 'Non-TLS URL' }
	}

	const downloadApiMatch = trimmed.match(GCS_DOWNLOAD_API_REGEX)
	if (downloadApiMatch) {
		const bucket = downloadApiMatch[1]
		const encodedObject = downloadApiMatch[2]
		try {
			const objectPath = decodeURIComponent(encodedObject)
			return {
				url: `https://storage.googleapis.com/${bucket}/${objectPath}`,
			}
		} catch {
			return { url: null, error: 'Invalid encoded object path' }
		}
	}

	if (!trimmed.startsWith('https://')) {
		return { url: null, error: 'URL must use HTTPS' }
	}

	return { url: trimmed }
}

export function assertPublicCampaignImageUrl(url: string): Promise<void> {
	return new Promise((resolve, reject) => {
		const img = new Image()
		img.onload = () => resolve()
		img.onerror = () => reject(new Error('Image not accessible'))
		img.src = url
	})
}
